import { IDashboardDictionary } from "~/lang/types/dashboard"

export const dashboardDictionary: IDashboardDictionary = {
  canceled: {
    title: "بار شرکت آونگ - غذایی توسط ادمین (سارا حسینی) لغو شده است!",
  },
  pending: {
    title: "آیا بار شرکت آونگ - غذایی مورد تائید می باشد؟",
    confirm: "تایید بار",
    reject: "رد کردن بار",
  },
  billOfLading: {
    billOfLadingPrice: "مبلغ بارنامه",
  },
}
